import Vue from "vue";

export default {
  async upload(formData) {
    return Vue.axios.post("import", formData).then(res => res.data);
  },

  async getUploadLogs(id, lastUpdate) {
    const param = lastUpdate ? `?lastUpdate=${lastUpdate}` : "";
    const response = await Vue.axios.get(`import/${id}${param}`);
    return response.data;
  }
};
